/* eslint-disable */
/* Code generated by generator.ts DO NOT EDIT. */
// Generated: 04-11-2026 08:35:03

export enum Interventielaag {
    GOEDE_AANWEZIGHEID = "Goede aanwezigheid",
    BEGINNEND_VERZUIM = "Beginnend verzuim",
    AANHOUDEND_VERZUIM = "Aanhoudend verzuim"
}
